
import React, { useState ,useEffect} from "react";
import Footer from "./Common/Footer";
import Header from "./Common/Header";
import CookieConsent, { Cookies } from "react-cookie-consent";

function Home() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (

    <div className="boxed_wrapper">

      <div><Header /></div>
      <div
        data-elementor-type="wp-page"
        data-elementor-id={162}
        className="elementor elementor-162"
      >
        <section
           className="elementor-section elementor-top-section elementor-element elementor-element-1265f20 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="1265f20"
          data-element_type="section"
          // data-settings='{"background_background":"classic"}'
          style={{ background: "#99d433" }}
          >
          <div className="auto-container">
            <div className="row align-items-center clearfix">
              <div className="col-lg-6 col-md-12 col-sm-12 image-column">
                <div className="image_block_3">
                  <div className="image-box">
                    <div className="shape">
                      <div
                        className="shape-1 rotate-me"
                        style={{
                          backgroundImage: "url(assets/images/shape/shape-18.png)"
                        }}
                      />
                      <div
                        className="shape-2 rotate-me"
                        style={{
                          backgroundImage: "url(assets/images/shape/shape-19.png)"
                        }}
                      />
                      {/* <div
                        className="shape-3"
                        style={{
                          backgroundImage: "url(assets/images/shape/shape-20.png)"
                        }}
                      /> */}
                    </div>
                    <figure className="image">
                      <img src="assets/theame/images/service_Photo/hero2.png" alt="" />
                    </figure>

                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-12 col-sm-12 content-column">
                <div className="content_block_1">
                  <div className="content-box">
                    {/* <div className="sec-title">

                      <h2>Our Human Resource Values</h2>
                    </div> */}
                    <div className="bold-text">
                     
                      <p>
                      Welcome to Job Trinity, your trusted partner in workforce solutions. Our mission is to simplify staffing and workforce management, delivering tailored solutions that drive growth, innovation, and success while empowering the Indian workforce—skilled, technical, or unskilled—to collaborate with innovative companies worldwide. With a vision to become the most reliable and preferred partner for businesses, we aim to connect exceptional talent with forward-thinking companies, creating a brighter future for all. Offering a broad range of manpower solutions, including IT and non-IT technical expertise, skilled trades, and unskilled labor, we ensure your unique needs are met with quality and professionalism. At Job Trinity, we believe people are the backbone of every successful business, and by bridging the gap between talent and opportunity, we help both businesses and individuals achieve sustainable success. Let us help you build a stronger, more capable workforce today.
                      </p>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-1c1efd3 elementor-section-full_width elementor-section-height-default elementor-section-height-default"
          data-id="1c1efd3"
          data-element_type="section"
          data-settings='{"background_background":"classic"}'
        >
          <div className="elementor-container elementor-column-gap-default">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-e51db8e"
              data-id="e51db8e"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <section
                  className="elementor-section elementor-inner-section elementor-element elementor-element-c0f067b elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="c0f067b"
                  data-element_type="section"
                >
                  <div className="elementor-container elementor-column-gap-default">
                    <div
                      className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-e27482c"
                      data-id="e27482c"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-497661a elementor-widget elementor-widget-heading bdevs-el heading"
                          data-id="497661a"
                          data-element_type="widget"
                          data-settings='{"design_style":"style_1"}'
                          data-widget_type="heading.default"
                        >
                          <div className="elementor-widget-container">
                            <div
                              className="section_title_wrapper mgsection_title-bottoms  wow fadeInUp"
                              data-wow-delay="0.3s"
                            >
                              {/* <span className="subtitle bdevs-el-subtitle">
                                Service Achievement{" "}
                              </span> */}
                              <h2 className="section-title section-title-black bdevs-el-title">
                                Our Mission{" "}
                              </h2>
                              <span>
                                Our mission is to simplify staffing and workforce management, delivering tailored solutions that help companies grow, innovate, and succeed. And give the opportunity to the Indian professional workforce from Skilled, Technical to Unskilled workers to work with innovative companies.{" "}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <div
                  className="elementor-element elementor-element-0509cdf elementor-widget elementor-widget-service bdevs-el service"
                  data-id="0509cdf"
                  data-element_type="widget"
                  data-settings='{"design_style":"style_3"}'
                  data-widget_type="service.default"
                >
                  <div className="elementor-widget-container">
                    <section className="service-achievement">
                      <div className="container">
                        <div className="row">
                          <div className="col-xxl-6 col-xl-6 col-lg-6">
                            <div
                              className="sr-achievement__thumb d-flex p-relative mb-30 wow fadeInUp"
                              data-wow-delay="0.3s"
                            >
                              <div className="sr-achievement__thumb-left mr-20">
                                <div className="sr-achievement__thumb-left-img1 mb-20">
                                  <img
                                    decoding="async"
                                    src="assets/theame/images/service_Photo/7.jpeg"
                                    // src="assets/theame/images/service_Photo/about-n1.png"
                                    // src="assets/theame/wp-content/uploads/2022/02/achi-1.jpg"
                                    alt="image not found"
                                    style={{ height: '250px', width: '250px' }}
                                  />
                                </div>
                                <div className="sr-achievement__thumb-left-img2">
                                  <img
                                    decoding="async"
                                    src="assets/theame/images/service_Photo/12.jpg"
                                    alt="image not found"
                                    style={{ height: '250px', width: '250px' }}
                                  />
                                </div>
                              </div>
                              <div className="sr-achievement__thumb-right">
                                <div className="sr-achievement__thumb-right-img1">
                                  <img
                                    decoding="async"
                                    src="assets/theame/images/service_Photo/13.jpg"
                                    alt="image not found"
                                    style={{ height: '520px', width: '250px' }}
                                  />
                                </div>
                              </div>
                              <div className="achievement-batch">
                                <img
                                  decoding="async"
                                  src="assets/theame/images/service_Photo/14.png"
                                  alt="image not found"
                                  style={{
                                    height: '250px', width: '250px',
                                    borderRadius: "50%", // Makes it circular
                                    overflow: "hidden", // Ensures no content overflows
                                    objectFit: "cover", // Ensures the image fits well
                                    border: "2px solid #000", // Optional: Add a border
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-xxl-6 col-xl-6 col-lg-6">
                            <div className="business-quality-group" style={{ textAlign: 'justify' }}>
                              {/* ml-30 pr-100 */}
                              <div className="business-quality wow fadeInUp" data-wow-delay="0.3s">
                                <div className="success__single d-flex megamau-success-single-3 mb-30">
                                  <div className="success__single-icon2 mt-10 mr-35">
                                   
                                      <i className="bdevs-btn-icon fal fa-trophy-alt" aria-hidden="true" />{" "}
                                   
                                  </div>
                                  <div className="success__single-text success__single-text2">
                                    {/* <span className="bdevs-el-list_subtitle">
                                      By Business Forum
                                    </span> */}
                                    <h5 className="success-title mb-15 bdevs-el-list_title">
                                     
                                        Our Vision
                                    
                                    </h5>
                                    <p className="bdevs-el-list_description">
                                      To become the most reliable and preferred partner for businesses seeking manpower solutions, empowering them to achieve sustained success through the power of exceptional talent. Combining talented people with innovative companies, we can build a brighter future for everyone.
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="business-quality wow fadeInUp"
                                data-wow-delay="0.3s"
                              >
                                <div className="success__single d-flex megamau-success-single-3 mb-30">
                                  <div className="success__single-icon2 mt-10 mr-35">
                                   
                                      <i
                                        aria-hidden="true"
                                        className=" flaticon-support"
                                      />{" "}
                                   
                                  </div>
                                  <div className="success__single-text success__single-text2">
                                    {/* <span className="bdevs-el-list_subtitle">
                                      By Business Forum
                                    </span> */}
                                    <h5 className="success-title mb-15 bdevs-el-list_title">
                                  
                                        Why Choose Us?
                                    
                                    </h5>
                                    <p className="bdevs-el-list_description">
                                      At Job Trinity, we don’t just provide manpower—we provide the right people to fuel your company’s success. Let us help you build a stronger, more capable workforce.
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="business-quality wow fadeInUp"
                                data-wow-delay="0.3s"
                              >
                                <div className="success__single d-flex megamau-success-single-3 mb-30">
                                  <div className="success__single-icon2 mt-10 mr-35">
                                 
                                      <i
                                        className="bdevs-btn-icon  flaticon-worker"
                                        aria-hidden="true"
                                      />{" "}
                                  
                                  </div>
                                  <div className="success__single-text success__single-text2">
                                    {/* <span className="bdevs-el-list_subtitle">
                                      By Business Forum
                                    </span> */}
                                    <h5 className="success-title mb-15 bdevs-el-list_title">
                                    
                                        Our Services
                                   
                                    </h5>
                                    <p className="bdevs-el-list_description">
                                      At Job Trinity, we offer a broad range of manpower solutions to cater to the unique needs of various industries. Whether you're seeking technical expertise, skilled professionals, or unskilled labor, we have the right talent to support your business objectives. Our services include.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-1265f20 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="1265f20"
          data-element_type="section"
          // data-settings='{"background_background":"classic"}'
          style={{ background: "#99d433" }}
        >
          <div className="elementor-container elementor-column-gap-default">
            <div
              className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-5009d4b"
              data-id="5009d4b"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-d612e17 elementor-widget elementor-widget-heading bdevs-el heading"
                  data-id="d612e17"
                  data-element_type="widget"
                  data-settings='{"design_style":"style_1"}'
                  data-widget_type="heading.default"
                >
                  <div className="elementor-widget-container">
                    <div
                      className="section_title_wrapper mgsection_title-bottoms  wow fadeInUp"
                      data-wow-delay="0.3s"
                    >
                      <span className="subtitle bdevs-el-subtitle" style={{ color: "white" }}>
                        About Us{" "}
                      </span>
                      <h2 className="section-title section-title-black" style={{ color: "black" }}>
                        Empowering Workforce Solutions{" "}
                      </h2>
                    </div>
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-da68681 elementor-widget elementor-widget-testimonial_slider bdevs-el testimonial_slider"
                  data-id="da68681"
                  data-element_type="widget"
                  data-settings='{"design_style":"style_1"}'
                  data-widget_type="testimonial_slider.default"
                >
                  <div className="elementor-widget-container">
                    {/* Client Reviews area start */}
                    <section className="client-reviews-area services-ex-bgg">
                      <div
                        className="client-active swiper-container"
                      // data-wow-delay="0.6s"
                      >
                        <div className="swiper-wrapper">
                          <div
                            className="client"
                            data-swiper-autoplay=""
                          >
                            <div className="testimonial-text mb-50 bdevs-el-content">
                              <p style={{ color: "black" }}>
                                At Job Trinity, we believe that people are the backbone of every successful business, and meaningful, sustainable employment has the power to change the world.
                              </p>
                              <p style={{ color: "black" }}>
                                As a leading provider of manpower solutions, we are dedicated to connecting businesses with the skilled and qualified talent they need to thrive in today’s dynamic marketplace. With years of industry experience, we understand the unique challenges that businesses face when it comes to finding the right workforce.
                              </p>
                            </div>
                            {/* <div className="testimonial-author d-flex align-items-center">
                              <div className="testimonial-author-icon mr-30">
                                <i className="fal fa-quote-left" />
                              </div>
                              <div className="testimonial-author-text">
                                <h5 className="uppercase bdevs-el-title">
                                  Jessica Brown
                                </h5>
                                <span className="bdevs-el-subtitle">
                                  House Holder
                                </span>
                              </div>
                            </div> */}
                          </div>
                          {/* <div
                            className="client swiper-slide"
                            data-swiper-autoplay=""
                          >
                            <div className="testimonial-text mb-50 bdevs-el-content">
                              <p>
                                Gravida augue erat nullam id tellus mattis vehicula
                                facilisic aliquet euismos litora ullamcorper morbina
                                suspendisse vitae vestibulum eros vitae. pede nullam
                                nullas ultricies corne mone molestie erate montes
                                adipiscing leoest magnis imperdiet fermentum auctor
                                hymenae laoren
                              </p>
                            </div>
                            <div className="testimonial-author d-flex align-items-center">
                              <div className="testimonial-author-icon mr-30">
                                <i className="fal fa-quote-left" />
                              </div>
                              <div className="testimonial-author-text">
                                <h5 className="uppercase bdevs-el-title">
                                  Jessica Brown
                                </h5>
                                <span className="bdevs-el-subtitle">
                                  House Holder
                                </span>
                              </div>
                            </div>
                          </div> */}
                        </div>
                      </div>
                    </section>
                    {/* Client Reviews area end */}
                  </div>
                </div>
              </div>
            </div>
            <div
              className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-4e08ee4"
              data-id="4e08ee4"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-4b885c4 elementor-widget elementor-widget-fact bdevs-el fact"
                  data-id="4b885c4"
                  data-element_type="widget"
                  data-settings='{"design_style":"style_1"}'
                  data-widget_type="fact.default"
                >
                  <div className="elementor-widget-container">
                    {/* Client Reviews area start */}
                    <section className="client-reviews-area services-ex-bgg">
                      <div className="achievement-group">
                        <img
                          decoding="async"
                          src="assets/theame/images/service_Photo/2.jpeg"
                          alt="image not found"
                          style={{
                            height: 'auto'
                            , width: 'auto'
                            // borderRadius: "50%", // Makes it circular
                            // overflow: "hidden", // Ensures no content overflows
                            // objectFit: "cover", // Ensures the image fits well
                            // border: "2px solid #000", // Optional: Add a border
                          }}
                        />
                        {/* <div
                          className="elementor-repeater-item-0313003 achievement-item mb-30 wow fadeInUp "
                          data-wow-delay="0.3s"
                        >
                          <ul className="achievement-item-box bdevs-el-content d-flex align-items-center">
                            <li className="bdevs-el-icon">
                              <figure>
                                <i
                                  aria-hidden="true"
                                  className=" flaticon-support"
                                />
                              </figure>
                            </li>
                            <li>
                              <h2 className="counter-count bdevs-el-title">
                                <span className="counter">120 </span>+
                              </h2>
                              <p className="counter-title">expert employee</p>
                            </li>
                          </ul>
                        </div>
                        <div
                          className="elementor-repeater-item-bb477f7 achievement-item mb-30 wow fadeInUp "
                          data-wow-delay="0.3s"
                        >
                          <ul className="achievement-item-box bdevs-el-content d-flex align-items-center">
                            <li className="bdevs-el-icon">
                              <figure>
                                <i aria-hidden="true" className=" flaticon-medal" />
                              </figure>
                            </li>
                            <li>
                              <h2 className="counter-count bdevs-el-title">
                                <span className="counter">325 </span>+
                              </h2>
                              <p className="counter-title">Completed Project</p>
                            </li>
                          </ul>
                        </div>
                        <div
                          className="elementor-repeater-item-e57e820 achievement-item mb-30 wow fadeInUp "
                          data-wow-delay="0.3s"
                        >
                          <ul className="achievement-item-box bdevs-el-content d-flex align-items-center">
                            <li className="bdevs-el-icon">
                              <figure>
                                <i
                                  aria-hidden="true"
                                  className=" flaticon-recovered"
                                />
                              </figure>
                            </li>
                            <li>
                              <h2 className="counter-count bdevs-el-title">
                                <span className="counter">235 </span>+
                              </h2>
                              <p className="counter-title">Happy customer</p>
                            </li>
                          </ul>
                        </div> */}
                      </div>
                    </section>
                    {/* Client Reviews area end */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-a190f38 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="a190f38"
          data-element_type="section"
        >
          <div className="elementor-container elementor-column-gap-default">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-77ad68c"
              data-id="77ad68c"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-22c96bf elementor-widget elementor-widget-heading bdevs-el heading"
                  data-id="22c96bf"
                  data-element_type="widget"
                  data-settings='{"design_style":"style_2"}'
                  data-widget_type="heading.default"
                >
                  <div className="elementor-widget-container">
                    <div
                      className="section_title_wrapper text-center wow fadeInUp"
                      data-wow-delay="0.3s"
                    >
                      <h2 className="msection-title bdevs-el-title">
                        <span>Industries</span> We Serve
                        {/* Popular <span>Services</span> */}
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-f7eba66 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="f7eba66"
          data-element_type="section"
        >
          <div className="elementor-container elementor-column-gap-default">
            <div
              className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-601ea6b"
              data-id="601ea6b"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-b5f31f0 elementor-widget elementor-widget-post_list bdevs-el post_list"
                  data-id="b5f31f0"
                  data-element_type="widget"
                  data-settings='{"design_style":"style_2"}'
                  data-widget_type="post_list.default"
                >
                  <div className="elementor-widget-container">
                    {/* mblog area start here */}
                    <div className="mblog-pd wow fadeInUp" data-wow-delay="0.3s">
                      <div className="mblog">
                        <div className="mblog__thumb p-relative">
                          <div className="mblog__thumb-img">
                           
                              <img
                                decoding="async"
                                src="assets/theame/images/emp_image/trending-services-1.jpg"
                                alt="img not found"
                                style={{ height: '200px' }}
                              />
                          
                          </div>
                          <div className="mblog__tag" style={{ color: "black" }}>

                          
                              IT & Software Development
                           
                          </div>
                        </div>
                        <div className="mblog__content smblog__content bdevs-el-content" style={{ height: '150px' }}>
                          <p style={{ fontSize: "medium", color: "black" }}>
                           
                              Developers, testers, designers, project managers, and IT support professionals.
                          
                          </p>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-a8ed027"
              data-id="a8ed027"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-0745780 elementor-widget elementor-widget-post_list bdevs-el post_list"
                  // data-id={0745780}
                  data-element_type="widget"
                  data-settings='{"design_style":"style_2"}'
                  data-widget_type="post_list.default"
                >
                  <div className="elementor-widget-container">
                    {/* mblog area start here */}
                    <div className="mblog-pd wow fadeInUp" data-wow-delay="0.3s">
                      <div className="mblog">
                        <div className="mblog__thumb p-relative">
                          <div className="mblog__thumb-img">
                           
                              <img
                                decoding="async"
                                src="assets/theame/images/emp_image/trending-services-2.jpg"
                                alt="img not found"
                                style={{ height: '200px' }}
                              />
                          
                          </div>
                          <div className="mblog__tag" style={{ color: "black" }}>
                            
                              {/* <i aria-hidden="true" className="far fa-folder-open" /> */}
                              Healthcare & Medical
                            
                          </div>
                        </div>
                        <div className="mblog__content smblog__content bdevs-el-content">
                          <p style={{ fontSize: "medium", color: "black" }}>
                           
                              Nurses, healthcare assistants, medical billing experts, and telemedicine staff.
                           
                          </p>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-905d7cb"
              data-id="905d7cb"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-4f33a63 elementor-widget elementor-widget-post_list bdevs-el post_list"
                  data-id="4f33a63"
                  data-element_type="widget"
                  data-settings='{"design_style":"style_2"}'
                  data-widget_type="post_list.default"
                >
                  <div className="elementor-widget-container">
                    {/* mblog area start here */}
                    <div className="mblog-pd wow fadeInUp" data-wow-delay="0.3s">
                      <div className="mblog">
                        <div className="mblog__thumb p-relative">
                          <div className="mblog__thumb-img">
                          
                              <img
                                decoding="async"
                                src="assets/theame/images/emp_image/trending-services-6.jpeg"
                                alt="img not found"
                                style={{ height: '200px' }}
                              />
                          </div>
                          <div className="mblog__tag" style={{ color: "black", padding: "5px" }}>
                          
                              {/* <i aria-hidden="true" className="far fa-folder-open" /> */}
                              Manufacturing & Engineering
                           
                          </div>
                        </div>
                        <div className="mblog__content smblog__content bdevs-el-content">
                          <p style={{ fontSize: "medium", color: "black" }}>
                           
                              Skilled labour, engineers, machine operators, and quality inspectors.
                           
                          </p>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-905d7cb"
              data-id="905d7cb"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-4f33a63 elementor-widget elementor-widget-post_list bdevs-el post_list"
                  data-id="4f33a63"
                  data-element_type="widget"
                  data-settings='{"design_style":"style_2"}'
                  data-widget_type="post_list.default"
                >
                  <div className="elementor-widget-container">
                    {/* mblog area start here */}
                    <div className="mblog-pd wow fadeInUp" data-wow-delay="0.3s">
                      <div className="mblog">
                        <div className="mblog__thumb p-relative">
                          <div className="mblog__thumb-img">
                           
                              <img
                                decoding="async"
                                src="assets/theame/images/emp_image/trending-services-5.jpeg"
                                alt="img not found"
                                style={{ height: '200px' }}
                              />
                           
                          </div>
                          <div className="mblog__tag" style={{ color: "black", padding: "5px" }}>
                           
                              {/* <i aria-hidden="true" className="far fa-folder-open" /> */}
                              Retail & E-Commerce
                           
                          </div>
                        </div>
                        <div className="mblog__content smblog__content bdevs-el-content">
                          <p style={{ fontSize: "medium", color: "black" }}>
                          
                              Sales associates, warehouse staff, customer service representatives
                          
                          </p>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="elementor-container elementor-column-gap-default">
            <div
              className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-601ea6b"
              data-id="601ea6b"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-b5f31f0 elementor-widget elementor-widget-post_list bdevs-el post_list"
                  data-id="b5f31f0"
                  data-element_type="widget"
                  data-settings='{"design_style":"style_2"}'
                  data-widget_type="post_list.default"
                >
                  <div className="elementor-widget-container">
                    {/* mblog area start here */}
                    <div className="mblog-pd wow fadeInUp" data-wow-delay="0.3s">
                      <div className="mblog">
                        <div className="mblog__thumb p-relative">
                          <div className="mblog__thumb-img">
                            
                              <img
                                decoding="async"
                                src="assets/theame/images/emp_image/trending-services-1.jpg"
                                alt="img not found"
                                style={{ height: '200px' }}
                              />
                          
                          </div>
                          <div className="mblog__tag" style={{ color: "black" }}>

                            
                              Finance & Accounting
                           
                          </div>
                        </div>
                        <div className="mblog__content smblog__content bdevs-el-content" style={{ height: '150px' }}>
                          <p style={{ fontSize: "medium", color: "black" }}>
                           
                              Accountants, auditors, tax consultants, and back-office support.
                            
                          </p>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-a8ed027"
              data-id="a8ed027"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-0745780 elementor-widget elementor-widget-post_list bdevs-el post_list"
                  // data-id={0745780}
                  data-element_type="widget"
                  data-settings='{"design_style":"style_2"}'
                  data-widget_type="post_list.default"
                >
                  <div className="elementor-widget-container">
                    {/* mblog area start here */}
                    <div className="mblog-pd wow fadeInUp" data-wow-delay="0.3s">
                      <div className="mblog">
                        <div className="mblog__thumb p-relative">
                          <div className="mblog__thumb-img">
                       
                              <img
                                decoding="async"
                                src="assets/theame/images/emp_image/trending-services-2.jpg"
                                alt="img not found"
                                style={{ height: '200px' }}
                              />
                      
                          </div>
                          <div className="mblog__tag" style={{ color: "black" }}>
                          
                              {/* <i aria-hidden="true" className="far fa-folder-open" /> */}
                              Logistics & Supply Chain
                        
                          </div>
                        </div>
                        <div className="mblog__content smblog__content bdevs-el-content">
                          <p style={{ fontSize: "medium", color: "black" }}>
                           
                              Warehouse personnel, drivers, inventory managers, and dispatchers.
                        
                          </p>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-905d7cb"
              data-id="905d7cb"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-4f33a63 elementor-widget elementor-widget-post_list bdevs-el post_list"
                  data-id="4f33a63"
                  data-element_type="widget"
                  data-settings='{"design_style":"style_2"}'
                  data-widget_type="post_list.default"
                >
                  <div className="elementor-widget-container">
                    {/* mblog area start here */}
                    <div className="mblog-pd wow fadeInUp" data-wow-delay="0.3s">
                      <div className="mblog">
                        <div className="mblog__thumb p-relative">
                          <div className="mblog__thumb-img">
                          
                              <img
                                decoding="async"
                                src="assets/theame/images/emp_image/trending-services-6.jpeg"
                                alt="img not found"
                                style={{ height: '200px' }}
                              />
                           
                          </div>
                          <div className="mblog__tag" style={{ color: "black", padding: "5px" }}>
                          
                              {/* <i aria-hidden="true" className="far fa-folder-open" /> */}
                              Hospitality & Customer Service
                          
                          </div>
                        </div>
                        <div className="mblog__content smblog__content bdevs-el-content">
                          <p style={{ fontSize: "medium", color: "black" }}>
                           
                              Front desk executives, housekeeping staff, and call center agents.
                           
                          </p>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-905d7cb"
              data-id="905d7cb"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-4f33a63 elementor-widget elementor-widget-post_list bdevs-el post_list"
                  data-id="4f33a63"
                  data-element_type="widget"
                  data-settings='{"design_style":"style_2"}'
                  data-widget_type="post_list.default"
                >
                  <div className="elementor-widget-container">
                    {/* mblog area start here */}
                    <div className="mblog-pd wow fadeInUp" data-wow-delay="0.3s">
                      <div className="mblog">
                        <div className="mblog__thumb p-relative">
                          <div className="mblog__thumb-img">
                       
                              <img
                                decoding="async"
                                src="assets/theame/images/emp_image/trending-services-5.jpeg"
                                alt="img not found"
                                style={{ height: '200px' }}
                              />
                           
                          </div>
                          <div className="mblog__tag" style={{ color: "black", padding: "5px" }}>
                           
                              {/* <i aria-hidden="true" className="far fa-folder-open" /> */}
                              Fleet Maintenance & Automotive
                           
                          </div>
                        </div>
                        <div className="mblog__content smblog__content bdevs-el-content">
                          <p style={{ fontSize: "medium", color: "black" }}>
                          
                              Fleet technicians, mechanics, vehicle inspectors, and maintenance personnel.
                           
                          </p>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div className="elementor-container elementor-column-gap-default">
            <div
              className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-601ea6b"
              data-id="601ea6b"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-b5f31f0 elementor-widget elementor-widget-post_list bdevs-el post_list"
                  data-id="b5f31f0"
                  data-element_type="widget"
                  data-settings='{"design_style":"style_2"}'
                  data-widget_type="post_list.default"
                >
                  <div className="elementor-widget-container">
                    {/* mblog area start here */}
                    <div className="mblog-pd wow fadeInUp" data-wow-delay="0.3s">
                      <div className="mblog">
                        <div className="mblog__thumb p-relative">
                          <div className="mblog__thumb-img">
                          
                              <img
                                decoding="async"
                                src="assets/theame/images/emp_image/trending-services-1.jpg"
                                alt="img not found"
                                style={{ height: '200px' }}
                              />
                          
                          </div>
                          <div className="mblog__tag" style={{ color: "black" }}>

                            
                              Cooks & Chefs
                          
                          </div>
                        </div>
                        <div className="mblog__content smblog__content bdevs-el-content" style={{ height: '150px' }}>
                          <p style={{ fontSize: "medium", color: "black" }}>
                         
                            Chefs, sous chefs, line cooks, pastry chefs, and kitchen assistants.
                         
                          </p>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-a8ed027"
              data-id="a8ed027"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-0745780 elementor-widget elementor-widget-post_list bdevs-el post_list"
                  // data-id={0745780}
                  data-element_type="widget"
                  data-settings='{"design_style":"style_2"}'
                  data-widget_type="post_list.default"
                >
                  <div className="elementor-widget-container">
                    {/* mblog area start here */}
                    <div className="mblog-pd wow fadeInUp" data-wow-delay="0.3s">
                      <div className="mblog">
                        <div className="mblog__thumb p-relative">
                          <div className="mblog__thumb-img">
                         
                              <img
                                decoding="async"
                                src="assets/theame/images/emp_image/trending-services-2.jpg"
                                alt="img not found"
                                style={{ height: '200px' }}
                              />
                          
                          </div>
                          <div className="mblog__tag" style={{ color: "black" }}>
                           
                              {/* <i aria-hidden="true" className="far fa-folder-open" /> */}
                              Drivers
                           
                          </div>
                        </div>
                        <div className="mblog__content smblog__content bdevs-el-content">
                          <p style={{ fontSize: "medium", color: "black" }}>
                           
                            Commercial truck drivers, delivery drivers, taxi and rideshare drivers, and specialized vehicle operators.
                         
                          </p>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-905d7cb"
              data-id="905d7cb"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-4f33a63 elementor-widget elementor-widget-post_list bdevs-el post_list"
                  data-id="4f33a63"
                  data-element_type="widget"
                  data-settings='{"design_style":"style_2"}'
                  data-widget_type="post_list.default"
                >
                  <div className="elementor-widget-container">
                    {/* mblog area start here */}

                  </div>
                </div>
              </div>
            </div>
            <div
              className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-905d7cb"
              data-id="905d7cb"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-4f33a63 elementor-widget elementor-widget-post_list bdevs-el post_list"
                  data-id="4f33a63"
                  data-element_type="widget"
                  data-settings='{"design_style":"style_2"}'
                  data-widget_type="post_list.default"
                >
                  <div className="elementor-widget-container">
                    {/* mblog area start here */}

                  </div>
                </div>
              </div>
            </div>

          </div>
        </section>

        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-b419eac elementor-section-full_width elementor-section-height-default elementor-section-height-default"
          data-id="b419eac"
          data-element_type="section"
          data-settings='{"background_background":"classic"}'
          style={{ background: "#99d433" }}
        >
          <div className="elementor-container elementor-column-gap-default">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-1210183"
              data-id={1210183}
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-5019c5e elementor-widget elementor-widget-cf7 bdevs-el cf7"
                  data-id="5019c5e"
                  data-element_type="widget"
                  data-settings='{"design_style":"style_4"}'
                  data-widget_type="cf7.default"
                >
                  <div className="elementor-widget-container">
                    <div className="footter__top footer__top-3 footer-bgg">
                      <div className="container">
                        <div className="row">
                          <div className="col-xl-4 col-lg-6">
                            <div
                              className="footer__subscribe-title wow fadeInUp"
                              data-wow-delay="0.3s"
                            >
                              <h2 className="big_title mb-0 msection-title mb-35" style={{ color: "black" }}>
                                Enquiry Now
                              </h2>
                            </div>
                          </div>
                          <div className="col-xl-8">
                            <div
                              className="footer__subscribe wow fadeInUp"
                              data-wow-delay="0.6s"
                            >
                              <div className="footer__subscribe-form footer__subscribe-form-2 footer__subscribe-form-3 p-relative">
                                <div
                                  className="wpcf7 no-js"
                                  id="wpcf7-f1484-p162-o1"
                                  lang="en-US"
                                  dir="ltr"
                                >
                                  <div className="screen-reader-response">
                                    <p
                                      role="status"
                                      aria-live="polite"
                                      aria-atomic="true"
                                    />
                                    <ul />
                                  </div>
                                  <form
                                    action="https://codeskdhaka.com/wp/megamau/#wpcf7-f1484-p162-o1"
                                    method="post"
                                    className="wpcf7-form init bdevs-cf7-form"
                                    aria-label="Contact form"
                                    noValidate="novalidate"
                                    data-status="init"
                                  >
                                    <div style={{ display: "none" }}>
                                      <input
                                        type="hidden"
                                        name="_wpcf7"
                                        defaultValue={1484}
                                      />
                                      <input
                                        type="hidden"
                                        name="_wpcf7_version"
                                        defaultValue="5.9.8"
                                      />
                                      <input
                                        type="hidden"
                                        name="_wpcf7_locale"
                                        defaultValue="en_US"
                                      />
                                      <input
                                        type="hidden"
                                        name="_wpcf7_unit_tag"
                                        defaultValue="wpcf7-f1484-p162-o1"
                                      />
                                      <input
                                        type="hidden"
                                        name="_wpcf7_container_post"
                                        defaultValue={162}
                                      />
                                      <input
                                        type="hidden"
                                        name="_wpcf7_posted_data_hash"
                                        defaultValue=""
                                      />
                                    </div>
                                    <p>
                                      <span
                                        className="wpcf7-form-control-wrap"
                                        data-name="email"
                                      >
                                        <input style={{ background: "white" }}
                                          size={40}
                                          maxLength={400}
                                          className="wpcf7-form-control wpcf7-email wpcf7-text wpcf7-validates-as-email"
                                          aria-invalid="false"
                                          placeholder="Email Address"
                                          defaultValue=""
                                          type="email"
                                          name="email"
                                        />
                                      </span>
                                      <br />
                                      <button className="theme-btn bdevs-el-btn" style={{ background: "black", color: "white" }}>
                                        Enquiry now
                                      </button>
                                    </p>
                                    <div
                                      className="wpcf7-response-output"
                                      aria-hidden="true"
                                    />
                                  </form>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div><Footer /></div>

      <CookieConsent
        enableDeclineButton
        flipButtons
        location="bottom"
        buttonText="Accept"
        cookieName="myAwesomeCookieName2"
        style={{ background: "#000" }}
        buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
        expires={150}
      >
        This website uses cookies to enhance the user experience.{" "}
      </CookieConsent>
    </div>
  );
}

export default Home;
